document.addEventListener("DOMContentLoaded", () => {
  const setupHeader = (header) => {
    const description = `<div>${header.innerHTML}</div>`;
    const icon = "<span data-sort-icon=''></span>";
    header.innerHTML = `<div style="cursor:pointer; display: flex;">${icon + description}</div>`;
  }

  document.querySelectorAll("[is='sortable-table']").forEach(table => {
    table.addEventListener("sort", sort);
    table.querySelectorAll("th").forEach((header, index) => {
      setupHeader(header);
      header.addEventListener("click", () => table.dispatchEvent(new CustomEvent("sort", {detail: {index: index}})));
    });
  });
});

function sort(event) {
  const extractSortAttributes = (event) => {
    const table = event.target;
    const tableBody = table.tBodies[0] || table.appendChild(document.createElement("tbody"));
    const tableHeader = table.querySelectorAll("th")[event.detail.index];
    const type = tableHeader.dataset.sortMethod || "STRING";
    const rows = Array.from(table.querySelectorAll("tr")).slice(1);
    const reverse = (event.detail.sortDirection || tableHeader.dataset.sortDirection) === "desc";
    return [table, tableBody, tableHeader, type, rows, reverse];
  }
  const sortRows = (a, b, reverse) => {
    const columnIndex = event.detail.index;
    const dataCellA = a.querySelectorAll("td")[columnIndex];
    const dataCellB = b.querySelectorAll("td")[columnIndex];
    [sortValueA, sortValueB] = extractSortValues(dataCellA, dataCellB, type, reverse);
    return compare(sortValueA, sortValueB, type, reverse);
  };
  const resetTableHeader = (tableHeader) => {
    tableHeader.querySelector("[data-sort-icon]").innerText = "";
    tableHeader.dataset.sortDirection = "";
  };
  const setTableHeader = (tableHeader) => {
    tableHeader.dataset.sortDirection = reverse ? "asc" : "desc";
    tableHeader.querySelector("[data-sort-icon]").innerText = reverse ? "▼" : "▲";
  }
  const [table, tableBody, tableHeader, type, rows, reverse] = extractSortAttributes(event);
  const sortedRows = [...rows].sort((a, b) => sortRows(a, b, reverse));
  rows.forEach(row => row.remove());
  sortedRows.forEach(row => tableBody.appendChild(row));
  table.querySelectorAll("th").forEach(resetTableHeader);
  setTableHeader(tableHeader);
  table.dispatchEvent(new CustomEvent("sortEnded"));
}

const extractSortValues = (dataCellA, dataCellB, type, reverse) => {
  const extractSortValue = (dataCell) => {
    const forType = {
      "NUMBER": (value) => JSON.parse(value),
      "DATE": (value) => new Date(value),
      "STRING": (value) => value
    }
    let extractedSortValueArray;
    if (!dataCell.dataset.sortValue) {
      extractedSortValueArray = [dataCell.innerText].flat();
    } else if (!forType[type]) {
      extractedSortValueArray = [dataCell.dataset.sortValue].flat();
    } else {
      extractedSortValueArray = [forType[type](dataCell.dataset.sortValue)].flat();
    }
    return reverse ? extractedSortValueArray.reverse() : extractedSortValueArray;
  }

  return [extractSortValue(dataCellA), extractSortValue(dataCellB)];
}

function compare(a, b, type, reverse) {
  const compareForType = {
    "NUMBER": (numberA, numberB) => numberA - numberB,
    "DATE": (dateA, dateB) => dateA.getTime() - dateB.getTime(),
    "STRING": (stringA, stringB) => stringA.localeCompare(stringB)
  }
  let i = 0;
  while (a.length > i && b.length > i) {
    const compareValue = compareForType[type](a[i], b[i]) * (reverse ? -1 : 1);
    if (compareValue !== 0) {
      return compareValue;
    }
    i++;
  }
  return a.length >= b.length ? 1 : 0;
}
